import { Avatar } from "@chakra-ui/avatar";
import { Button } from "@chakra-ui/button";
import { Divider, Flex, Heading } from "@chakra-ui/layout";
import { Layout } from "../Components/Layout";
import { useAuth } from "../contexts/authContext";
import firebase from "../firebase";

export const UserProfile = () => {
	const { currentUser } = useAuth();

	const deleteUser = () => {
		firebase.auth().currentUser.delete();
	};

	return (
		<Layout>
			<Flex
				w="100%"
				bgColor="gray.100"
				p={8}
				rounded="lg"
				alignItems="center"
				flexDir="column"
				justifyContent="center"
			>
				<Avatar size="xl" />
				<Heading mt={26} mb={5}>
					{currentUser.displayName}
				</Heading>
				<Divider mb={5} />
				<Heading size="md">{currentUser.email}</Heading>
				<Button
					variant="outline"
					colorScheme="red"
					color="red.400"
					mt={10}
					mb={5}
					onClick={deleteUser}
				>
					Temrinate Account
				</Button>
			</Flex>
		</Layout>
	);
};
